import { useDialog } from "../../../../hooks/useDialog";
import { useTranslation } from "react-i18next";
import ErrorMessage from "../../../atoms/controls/validation/ErrorMessage";
import CheckboxInput from "../../../atoms/controls/input/CheckboxInput";
import ConsentCheckboxLabel from "../../../atoms/controls/label/ConsentCheckboxLabel";

export default function ConsentCheckboxInputField({
  id,
  checked,
  onChange,
  required,
  formikTouched,
  error,
  consentText,
  labelItems,
  ...props
}) {
  const { showDialog } = useDialog();
  const { t } = useTranslation();

  const handleConsentClick = () => {
    consentText && showDialog("", consentText, t("dialog.okey"), false);
  };

  return (
    <div className="flex items-start">
      <CheckboxInput
        id={id}
        checked={checked}
        onChange={onChange}
        required={required}
        {...props}
      />
      <ConsentCheckboxLabel
        htmlFor={id}
        items={labelItems}
        onConsentClick={handleConsentClick}
      />
      <ErrorMessage touched={formikTouched} errors={error} />
    </div>
  );
}
